<template>
  <div>

<!-- <v-btn :disabled="groupPayJumpers.length < 1" :groupLoading="groupLoading" color="green" @click.stop="dialog = true"><v-icon>mdi-playlist-check</v-icon> <span class="text">Pay Together</span></v-btn> -->

  <v-dialog v-model="groupDialog" 
  @keydown.esc="groupDialog = false"
  max-width="600px"
  >
    <v-card>
      <v-card-title>
 Group Payment
      </v-card-title>

      <v-form @submit.prevent="payTogether" v-model="valid">
        <v-card-text>
              <!-- <v-select v-model="payer"
                  :items="groupPayJumpers"
                                      
                                      item-text="fullName"
                                      item-value="customer_id"
                                      label="Select who is paying"
                                      :rules="req"
                                      >
              </v-select> -->
          <v-data-table 
          class="no-footer-table"
            :headers="groupHeaders" 
            :items="allGroupItems" item-key="id">
        
          <template v-slot:item.price="{ item }">
                      <span >${{item.price}} </span>
                    </template>
                          <template slot="body.append">
                              <tr class="pink--text">
                                  <th class="title">Total</th>
                                  <th class="title">${{ sum(allGroupItems, 'price') }}</th>
                              </tr>
                          </template>
                      </v-data-table>
        </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="groupDialog = false">Close</v-btn>

           <v-btn  :loading="groupLoading" color="green" type="Submit" >
            <v-icon left>mdi-playlist-check</v-icon>Paid </v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-dialog>
</div>
    
</template>

<script>
    import { mapState } from 'vuex'
  

    export default {

      props : ['groupPayJumpers'],
      
        data() {


            return {

              groupDialog : false,

              groupLoading : false,
              

              groupHeaders : [
                    { text: 'Item', value: 'notes', align: 'start', sortable: true },
                    { text: 'Price', align: 'start', sortable: false, value: 'price'},                    
                    ],
              payer : null,

              req: [ v => !!(v && v.length) || 'Item is required'],

             
            }
        },


        computed: {

          jumpers () {
              return this.$store.getters.booked
            },

            customers () {

              return this.$store.state.customers

            },

            // groupPayJumpers() {
                     
            //   return this.customers.filter((el) => { 
            //     return this.groupPaymentIDs.includes(el.id)
            //   })

            // },


          allGroupItems() {

            let all = this.groupPayJumpers.reduce((a, { creditedItems }) => [...a, ...creditedItems], [])

           return all.filter((el) => { 
                return el.paymentStatus == 'pending'
              })
          }

        },


        methods: {

           payTogether() {

            this.$emit('pay')


          },

        }
    }
</script>